import { systemInfo } from "@/shared-services";

export let TokenKey = systemInfo.isCommand ? 'TP_PORTAL_TOKEN_V2' : 'DISPATCH_TOKEN'

export function getStorage(key = TokenKey) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return localStorage.getItem(key)
  }
}

export function setStorage(token, key=TokenKey) {
  localStorage.setItem('time',Date.now())
  return localStorage.setItem(key, JSON.stringify(token))
}

export function removeStorage(key = TokenKey) {
  return localStorage.removeItem(key);
}
export function removeSessionStorage(key = TokenKey) {
  return sessionStorage.removeItem(key);
}
// get_cache_size
export function get_cache_size(type = "s") {
  let obj = {},
    size = 0,
    cache_size = 0;
  if (type === "l") {
    if (!window.localStorage) {
      console.log("浏览器不支持localStorage");
    } else {
      obj = window.localStorage;
    }
  } else {
    if (!window.sessionStorage) {
      console.log("浏览器不支持sessionStorage");
    } else {
      obj = window.sessionStorage;
    }
  }
  if (JSON.stringify(obj) != "{}") {
    for (let item in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, item)) {
        size += obj.getItem(item).length;
      }
    }
    cache_size = (size / 1024).toFixed(2);
    console.log("当前已用存储：" + cache_size + "KB");
  }
  return cache_size;
}
